"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableCellClassName: function() {
        return tableCellClassName;
    },
    tableCellClassNames: function() {
        return tableCellClassNames;
    },
    useTableCellStyles_unstable: function() {
        return useTableCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableCellClassName = 'fui-TableCell';
const tableCellClassNames = {
    root: tableCellClassName
};
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    },
    medium: {
        Bqenvij: "f1ft4266"
    },
    small: {
        Bqenvij: "fbsu25e"
    },
    "extra-small": {
        Bqenvij: "frvgh55"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f1ft4266{height:44px;}",
        ".fbsu25e{height:34px;}",
        ".frvgh55{height:24px;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bf4jedk: "f10tiqix",
        Bt984gj: "f122n59",
        Bh6795r: "fqerorx",
        Bnnss6s: "f1neuvcm",
        xawz: "fkjuxzh"
    },
    medium: {
        sshi5w: "f5pgtk9"
    },
    small: {
        sshi5w: "fcep9tg"
    },
    "extra-small": {
        sshi5w: "f1pha7fy"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f10tiqix{min-width:0px;}",
        ".f122n59{align-items:center;}",
        ".fqerorx{flex-grow:1;}",
        ".f1neuvcm{flex-shrink:1;}",
        ".fkjuxzh{flex-basis:0px;}",
        ".f5pgtk9{min-height:44px;}",
        ".fcep9tg{min-height:34px;}",
        ".f1pha7fy{min-height:24px;}"
    ]
});
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        qhf8xq: "f10pi13n",
        z8tnut: "f1nbblvp",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "f1ov4xf1",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        Bn4voq9: "fz36nt7",
        g9k6zt: "f9znhxp",
        Bfpq7zp: "fqrak0z",
        kdpuga: [
            "f1o2ludy",
            "f1kjnpwc"
        ],
        Bw81rd7: [
            "f1kjnpwc",
            "f1o2ludy"
        ],
        B6xbmo0: [
            "fxmnebo",
            "f1witrsb"
        ],
        dm238s: [
            "f1witrsb",
            "fxmnebo"
        ]
    }
}, {
    d: [
        ".f10pi13n{position:relative;}",
        ".f1nbblvp{padding-top:0px;}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1ov4xf1{padding-bottom:0px;}",
        ".fz36nt7[data-fui-focus-visible]{outline-width:2px;}",
        ".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",
        ".fqrak0z[data-fui-focus-visible]{outline-color:var(--colorStrokeFocus2);}",
        ".f1o2ludy[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f1kjnpwc[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".fxmnebo[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusMedium);}",
        ".f1witrsb[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusMedium);}"
    ]
});
const useTableCellStyles_unstable = (state)=>{
    const styles = useStyles();
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableCellClassNames.root, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.noNativeElements ? layoutStyles.flex[state.size] : layoutStyles.table[state.size], state.root.className);
    return state;
}; //# sourceMappingURL=useTableCellStyles.styles.js.map
